<span class="tumbler" [ngClass]="{disabled: disabled}">
    <input
        type="checkbox"
        id="{{ id }}"
        #inputEl
        [required]="required"
        [checked]="checked"
        [disabled]="disabled"
        (change)="onChange()"
        (blur)="onBlur()"
    />
    <label for="{{ id }}" class="checkbox__fake"></label>
    <label for="{{ id }}" class="checkbox__label"><ng-content></ng-content></label>
</span>
